import {
  HeaderFrame,
  AccountModalOpenButton,
  HeaderLogo,
  ScanButton,
  SignUpButton,
} from '../header';

type ScreenHomeHeaderProps = {
  isSignedIn: boolean;
};

export function ScreenHomeHeader(props: ScreenHomeHeaderProps) {
  return (
    <HeaderFrame>
      <HeaderFrame.Left>
        <AccountModalOpenButton />
      </HeaderFrame.Left>
      <HeaderFrame.Middle>
        <HeaderLogo />
      </HeaderFrame.Middle>
      <HeaderFrame.Right>{props.isSignedIn ? <ScanButton /> : <SignUpButton />}</HeaderFrame.Right>
    </HeaderFrame>
  );
}
